import React, { useEffect, useState, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  Col,
  Row,
  Alert,
  Spinner,
} from "reactstrap"

// Formik validation
import * as Yup from "yup"
import { Formik, Field, ErrorMessage, FieldArray, useFormik } from "formik"

import { consoleShare, consoleResponseResetState } from "store/actions"

import ShareForm from "./forms/shareForm"

const ShareModal = props => {
  const { isOpen, toggleShareableModal, toggle, item, schema} = props

  const shareFormRef = useRef();
    
  const dispatch = useDispatch()

  const selectConsoleShare = state => state.console
  const ConsoleProperties = createSelector(selectConsoleShare, console => ({
    loading: console.loading,
    response: console.response,
    shareError: console.shareError,
  }))

  const { response, shareError, loading } = useSelector(selectConsoleShare)

  useEffect(() => {
    if(!shareError && !loading && response && _.has(response,'messageId') && response.messageId){
      dispatch(consoleResponseResetState())
      toggleShareableModal(false)
    }
  }, [response, shareError, loading])


  const handleFormSubmit = async () => {
    shareFormRef.current.handleSubmit()
  }

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggleShareableModal}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggleShareableModal}>
          {item && `Share ${item.name} 's Personalized Url`}
        </ModalHeader>
        <ModalBody>
          <Formik
            enableReinitialize={true}
            innerRef={shareFormRef}
            initialValues={
              schema.initialValues
            }
            validationSchema={
              schema.validationSchema
            }
            onSubmit={async values => {
              try {
                dispatch(consoleShare(values))
              } catch (error) {
                console.error({ error })
              }
            }}
            component={ShareForm}
          />
        </ModalBody>
        <ModalFooter>
          <Button 
            type="button" 
            color="primary"
            className={loading ? "btn btn-primary disabled" : "btn btn-primary"}
            onClick={event => {
              handleFormSubmit()
            }}
          >
            {loading ? (
              <>
                <Spinner size="sm">Loading...</Spinner>
                <span> sending</span>
              </>
            ) : (
              <>
                <i className="mdi mdi-share-variant font-size-16"></i>{"   Share Url"}
              </>
            )}
          </Button>
          <Button 
            type="button"
            className={loading ? "btn btn-light disabled" : "btn btn-light"}
            onClick={toggleShareableModal}
          >
            Cancel
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

ShareModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default ShareModal
